<template>
  <div class="over-48">
    <svg
      test-id="svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="100%"
      viewBox="0 0 82 93"
    >
      <defs><path id="a" d="M0 92.869h81.987V0H0z" /></defs>
      <g fill="none" fill-rule="evenodd">
        <path
          :fill="color"
          d="M20.11 35.192a4.325 4.325 0 0 0-4.322 4.318 4.325 4.325 0 0 0 4.322 4.318 4.325 4.325 0 0 0 4.322-4.318c0-2.38-1.939-4.318-4.322-4.318m0 9.823a5.514 5.514 0 0 1-5.51-5.505 5.514 5.514 0 0 1 5.51-5.505c3.038 0 5.51 2.47 5.51 5.505a5.514 5.514 0 0 1-5.51 5.505M14.173 47.358a2.529 2.529 0 0 0-2.527 2.525v11.259c0 1.181.838 2.22 1.993 2.467l.507.109-.04.516c-.004.065-.01.129-.01.194v13.766a2.53 2.53 0 0 0 2.528 2.526h6.972a2.53 2.53 0 0 0 2.528-2.526V64.428c0-.063-.005-.125-.01-.186l-.04-.516.507-.117a2.535 2.535 0 0 0 1.993-2.467V49.883a2.529 2.529 0 0 0-2.527-2.525H14.173zm9.423 34.549h-6.972a3.718 3.718 0 0 1-3.716-3.713V64.631a3.734 3.734 0 0 1-2.45-3.49V49.884a3.718 3.718 0 0 1 3.715-3.712h11.874a3.718 3.718 0 0 1 3.716 3.712v11.259a3.734 3.734 0 0 1-2.45 3.49v13.562a3.718 3.718 0 0 1-3.717 3.713zM40.994 35.192a4.325 4.325 0 0 0-4.323 4.318 4.325 4.325 0 0 0 4.323 4.318 4.325 4.325 0 0 0 4.322-4.318 4.325 4.325 0 0 0-4.322-4.318m0 9.823a5.514 5.514 0 0 1-5.511-5.505 5.514 5.514 0 0 1 5.51-5.505c3.039 0 5.511 2.47 5.511 5.505a5.514 5.514 0 0 1-5.51 5.505M35.057 47.358a2.529 2.529 0 0 0-2.528 2.525v11.259c0 1.181.839 2.219 1.994 2.467l.506.109-.039.516c-.005.065-.01.129-.01.194v13.766a2.53 2.53 0 0 0 2.528 2.526h6.972a2.53 2.53 0 0 0 2.528-2.526V64.428c0-.065-.006-.129-.01-.193l-.04-.516.507-.11a2.536 2.536 0 0 0 1.993-2.467V49.883a2.529 2.529 0 0 0-2.527-2.525H35.057zm9.423 34.549h-6.972a3.718 3.718 0 0 1-3.717-3.713V64.631a3.734 3.734 0 0 1-2.45-3.49V49.884a3.718 3.718 0 0 1 3.716-3.712H46.93a3.718 3.718 0 0 1 3.716 3.712v11.259a3.734 3.734 0 0 1-2.451 3.49v13.562a3.718 3.718 0 0 1-3.716 3.713zM61.878 35.192a4.325 4.325 0 0 0-4.323 4.318 4.325 4.325 0 0 0 4.323 4.318A4.325 4.325 0 0 0 66.2 39.51c0-2.38-1.94-4.318-4.322-4.318m0 9.823a5.514 5.514 0 0 1-5.511-5.505 5.514 5.514 0 0 1 5.51-5.505c3.039 0 5.511 2.47 5.511 5.505a5.514 5.514 0 0 1-5.51 5.505M55.94 47.358a2.529 2.529 0 0 0-2.527 2.525v11.259c0 1.181.838 2.22 1.994 2.467l.506.109-.039.516c-.005.07-.01.131-.01.194v13.766a2.53 2.53 0 0 0 2.527 2.526h6.973a2.53 2.53 0 0 0 2.527-2.526V64.428c0-.065-.005-.129-.01-.193l-.039-.516.507-.11a2.536 2.536 0 0 0 1.993-2.467V49.883a2.529 2.529 0 0 0-2.527-2.525H55.94zm9.424 34.549H58.39a3.718 3.718 0 0 1-3.716-3.713V64.631a3.734 3.734 0 0 1-2.45-3.49V49.884a3.718 3.718 0 0 1 3.716-3.712h11.874a3.718 3.718 0 0 1 3.715 3.712v11.259a3.734 3.734 0 0 1-2.45 3.49v13.562a3.718 3.718 0 0 1-3.716 3.713z"
        />
        <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
        <path
          :fill="color"
          d="M1.188 80.72h79.61V1.187H1.189V80.72zM0 81.907h81.987V0H0v81.907z"
          mask="url(#b)"
        />
        <path
          :fill="color"
          d="M7.004 81.313H5.815V23.402c0-4.577 3.727-8.3 8.309-8.3h53.74c4.581 0 8.308 3.723 8.308 8.3v57.764h-1.188V23.402c0-3.923-3.194-7.114-7.12-7.114h-53.74c-3.926 0-7.12 3.191-7.12 7.114v57.911zM12.141 89.319h57.705v-1.187H12.141z"
          mask="url(#b)"
        />
        <path
          :fill="color"
          d="M13.355 92.869l-7.183-4.144 7.183-4.143zM68.633 92.869l7.183-4.144-7.183-4.143z"
          mask="url(#b)"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'Over48',
  props: {
    color: VueTypes.string.isRequired,
  },
};
</script>

<style lang="scss" scoped>
.over-48 {
  width: 82px;
  height: 93px;
}

@media (max-width: $mobile-max-width) {
  .over-48 {
    width: 61px;
    height: 69px;
  }
}
</style>
